import {
  Select,
  Image,
  Form,
  Modal,
  Input,
  Popover,
  Button,
  Divider,
  Tooltip,
  Spin,
} from "antd";
import { useEffect, useState } from "react";
import "./index.less";
import { FixedSizeList as List } from "react-window";
import {
  CloseCircleFilled,
  CloseCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { formatBalance, getChainsResource } from "@/utils/methods";
import { cdnUrl } from "@/utils/cdn";
import { message } from "antd";
import { formatUnits } from "viem";
import { isSuiCoinType } from "@/utils/suiMethods";
import { isValidCoinType } from "@/utils/suiMethods";
import Loader from "@/components/Loader";
interface Props {
  disabled: any;
  currentDetail: any;
  canClear: any;
  setCurrentDetail: any;
  placeholder: any;
  inputDisabled: any;
  searchPlaceholder: any;
  inputChange: any;
  getSelectedTokenInfo: any;
  mintSearching: any;
  list: any;
  setList: any;
  storageLists: any;
  getTokens: any;
  clearInput: any;
}
const TokenModal = ({
  disabled,
  currentDetail,
  canClear,
  setCurrentDetail,
  placeholder,
  inputDisabled,
  searchPlaceholder,
  inputChange,
  getSelectedTokenInfo,
  mintSearching,
  list,
  setList,
  storageLists,
  getTokens,
  clearInput,
  //   handleRefreshClick,
}: Props) => {
  const { t } = useTranslation();
  const [isRequesting, setIsRequesting] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRefreshRotating, setIsRefreshRotating] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [searchValue, setSearchValue] = useState("");
  const [copyed, setCopyed] = useState("");
  // useEffect(() => {
  //   form.setFieldValue(formKey, currentDetail.address);
  // }, [currentDetail]);
  const filterByKeyword = (raw: string) => {
    const kwRaw = (raw || "").trim();
    const kw = (raw || "").trim().toLowerCase();
    setSearchValue(raw);

    // 为空：恢复全量
    if (!kw) {
      setList(storageLists);
      // inputChange?.(""); // 你如果还想通知父组件，可保留
      return;
    }

    const filtered = (storageLists || []).filter((item: any) => {
      const symbol = (item.symbol || "").toString().toLowerCase();
      const name = (item.name || "").toString().toLowerCase();
      const coinType = (item.coinType || "").toString().toLowerCase();

      return (
        symbol.includes(kw) ||
        name.includes(kw) ||
        coinType.includes(kw)
      );
    });
    // console.log("filtered", filtered)
    if (filtered.length == 0) {
      setList([])
      inputChange?.(kwRaw); // 你如果父组件还有其他逻辑（比如请求/埋点），可保留
    } else {
      setList(filtered);
    }
  };
  const userContent = (
    <div className="content1">{t("ListModalAntd.userToken")}</div>
  );
  const verifyContent = (
    <div className="content1">
      {t("customizedAuthorization.certifiedToken")}
    </div>
  );
  const escapeRegExp = (string: string) =>
    string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const isFullAddress = (text: string) =>
    /^0x[a-fA-F0-9]{40}$/.test(text.trim());

  const highlightMatch = (text: string, keyword: string) => {
    if (!keyword) return text;
    const lowerText = text.toLowerCase();
    const lowerKeyword = keyword.trim().toLowerCase();
    // ✅ 如果完全匹配地址，整段高亮
    if (isFullAddress(lowerKeyword) && lowerText === lowerKeyword) {
      return <span style={{ color: "#F0B90B" }}>{text}</span>;
    }
    // ✅ 否则模糊匹配部分高亮（symbol, name, address 都一样处理）
    const safeKeyword = escapeRegExp(lowerKeyword);
    const regex = new RegExp(`(${safeKeyword})`, "gi");
    const parts = text.split(regex);
    return parts.map((part, i) =>
      i % 2 === 1 ? (
        <span key={i} style={{ color: "#F0B90B" }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const isAddressMatch = (address: string, keyword: string) => {
    if (!keyword) return false;
    return address.toLowerCase().includes(keyword.toLowerCase());
  };

  const renderShortAddress = (coinType: string, keyword: string) => {
    const shortAddress = coinType.slice(0, 6) + "..." + coinType.slice(-4);
    const match = isAddressMatch(coinType, keyword);
    return match ? (
      <Tooltip title={coinType} color="rgba(102, 102, 102, 1)">
        <span style={{ color: "#F0B90B" }}>{shortAddress}</span>
      </Tooltip>
    ) : (
      <Tooltip title={coinType} color="rgba(102, 102, 102, 1)">
        <span>{shortAddress}</span>
      </Tooltip>
    );
  };
  //用户点击刷新按钮
  const handleRefreshClick = async () => {
    setIsRefreshRotating(true);
    setIsRequesting(true);
    setSearchValue("")
    setTimeout(() => {
      setIsRefreshRotating(false);
    }, 1000);
    await getTokens();
    setIsRequesting(false);
    message.open({
      type: "success",
      // content: "刷新成功",
      content: t("customizedAuthorization.refreshSuccess"),
    });
  };
  //复制地址
  const copy = async (content: any) => {
    await navigator.clipboard.writeText(content);
    messageApi.open({
      type: "success",
      // content: "复制成功",
      content: t("customizedAuthorization.pasteSuccess"),
    });
  };
  return (
    <>
      {contextHolder}
      <div
        className={disabled ? "list-modal-wrap cant-open" : "list-modal-wrap"}
        onClick={() => {
          !disabled && setIsModalOpen(true);
          setCopyed("");
        }}
      >
        <div className={"open-btn"}>
          {currentDetail.symbol ? (
            <div className="current">
              <div className="select-detail">
                <img
                  className="logo-img"
                  src={isSuiCoinType(currentDetail.coinType) ? cdnUrl("/img/chains/sui.svg") : currentDetail.iconUrl}
                  alt=""
                  onError={(e) => {
                    e.currentTarget.src = cdnUrl("/img/bsc/default-logo.svg");
                  }}
                />
                <div className="current-symbol">
                  <Tooltip
                    placement="topLeft"
                    title={<span>{currentDetail.symbol}</span>}
                    color="rgba(102, 102, 102, 1)"
                  >
                    {currentDetail.symbol}
                  </Tooltip>
                </div>
                <Divider type="vertical"></Divider>
                <div className="coinType-section">
                  <div>{currentDetail.coinType}</div>
                  <img className="" src={cdnUrl("/img/999999copy.svg")} alt="" onClick={(e) => {
                    e.stopPropagation();
                    copy(currentDetail.coinType)
                  }} />
                </div>
              </div>

              <div className="imgs">
                {/* <CloseCircleFilled /> */}
                {canClear && (
                  <CloseCircleFilled
                    className="clear-img"
                    onClick={(e) => {
                      e.stopPropagation();
                      clearInput();
                    }}
                  />
                )}
                {/* <img src={cdnUrl("/img/close-outlined.svg")} alt="" /> */}
                <img
                  className="dropdown-img"
                  src={cdnUrl("/img/bsc/dropArrow.svg")}
                  alt=""
                />
              </div>
            </div>
          ) : (
            <div className="place-holder">{placeholder}</div>
          )}
        </div>
        <Modal
          centered
          closable={false}
          title={null}
          open={isModalOpen}
          footer={null}
          wrapClassName="list-modal-antd"
        >
          {/* {"+" + isRequesting} */}
          <div className="header">
            <div className="header-left">
              <span className="select-coin">
                {t("customizedAuthorization.selectToken1")}
              </span>
              <Button
                type="primary"
                className="refresh-btn"
                icon={
                  <img
                    src={cdnUrl("/img/refresh.webp")}
                    alt=""
                    className={isRefreshRotating ? "rotating" : ""}
                  />
                }
                onClick={handleRefreshClick}
              />
            </div>
            <img
              src={cdnUrl("/img/close-outlined.svg")}
              alt=""
              className="close-icon"
              onClick={(e) => {
                e.stopPropagation();
                // console.log("8888");
                setSearchValue("");
                setList(storageLists);
                setIsModalOpen(false);
              }}
            />
          </div>
          <div className="select-input">
            {!inputDisabled && (
              <Input
                placeholder={searchPlaceholder}
                disabled={inputDisabled}
                prefix={<img src={cdnUrl("/img/bsc/search.png")}></img>}
                onChange={(e) => {
                  // inputChange(e.target.value.toLowerCase());
                  filterByKeyword(e.target.value)
                  setSearchValue(e.target.value);
                }}
                allowClear
                value={searchValue}
              ></Input>
            )}
          </div>
          <div className="coin-lists">
            {isRequesting ? (
              <div className="spin">
                <Spin indicator={<LoadingOutlined spin />} />
                <div>{t("ListModalAntd.coinLoading")}</div>
              </div>
            ) : list && list.length > 0 ? (
              <List
                height={Math.min(list.length * 59.281, 500)} // 容器高度，自己调整
                itemCount={list.length}
                itemSize={59.273}
                width="100%"

              >
                {({ index, style }) => {
                  const item = list[index];
                  const isActive =
                    (item?.coinType || "").toLowerCase() ===
                    (currentDetail?.coinType || "").toLowerCase();
                  return (
                    <div
                      style={style}
                      key={item.coinType}
                      className={`coin ${isActive ? "coin-active" : ""}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setCurrentDetail({ ...list[index] });
                        // getSelectedTokenInfo &&
                        //   getSelectedTokenInfo(list[index]);
                        setSearchValue("");
                        setIsModalOpen(false);
                        setList(storageLists);
                      }}
                    >
                      <div className="col-left">
                        <img
                          className="coin-logo"
                          src={isSuiCoinType(item.coinType) ? cdnUrl("/img/chains/sui.svg") : item.iconUrl}
                          alt=""
                          onError={(e) => {
                            e.currentTarget.src = cdnUrl(
                              "/img/bsc/default-logo.svg"
                            );
                          }}
                        />
                        <div>
                          <div className="name">
                            <Tooltip
                              title={item.symbol}
                              color="rgba(102, 102, 102, 1)"
                            >
                              {/* <div className="symbol">{item.symbol}</div> */}
                              <div className="symbol">
                                {highlightMatch(item.symbol, searchValue)}
                              </div>
                            </Tooltip>

                            {item.tokenType == "user" && <Popover
                              content={userContent}
                              title=""
                              color="rgba(102, 102, 102, 1)"
                            >
                              <img
                                className="guard-icon"
                                src={cdnUrl("/img/bsc/user.svg")}
                                alt=""
                              />
                            </Popover>}

                            {
                              item.tokenType == "official" && <Popover
                                content={verifyContent}
                                title=""
                                color="rgba(102, 102, 102, 1)"
                              >
                                <img
                                  className="guard-icon"
                                  src={cdnUrl("/img/bsc/guard.svg")}
                                  alt=""
                                />
                              </Popover>
                            }
                          </div>
                          <Tooltip
                            title={item.symbol}
                            color="rgba(102, 102, 102, 1)"
                          >
                            <div className="name-symbol"> {highlightMatch(item.name, searchValue)}</div>
                          </Tooltip>
                        </div>
                      </div>
                      <div className="col-right">
                        <div className="balance">
                          {Number(Number(formatUnits(item.totalBalance || BigInt(0), item.decimals)).toFixed(4))}
                        </div>
                        <div className="col-bottom">
                          <div className="address">{renderShortAddress(item.coinType, searchValue)}</div>
                          <img src={cdnUrl("/img/999999copy.svg")} alt="" onClick={(e: any) => {
                            e.stopPropagation();
                            copy(item.coinType)
                          }} />
                        </div>
                      </div>
                    </div>
                  );
                }}
              </List>
            ) : (
              <div className="no-found">
                {mintSearching ? (
                  <Spin indicator={<LoadingOutlined spin />} />

                ) : (
                  <img src={cdnUrl("/img/bsc/not-found-coin.png")} alt="" />
                )}
                <div>
                  {mintSearching
                    ? t("ListModalAntd.searching")
                    : t("ListModalAntd.noResult")}
                </div>
              </div>
            )}
          </div>
        </Modal>
      </div>
    </>
  );
};
export default TokenModal;
